import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'use-memo-one'

import { AsyncStateN } from '@blade/std-lib'
import { reatomUnlockSecureStorage } from '@root/features/secure-storage/atoms'
import { UnknownError } from '@root/shared'

import { WrongPasswordError } from '../secure-storage-error'

import { LocalPasswordForm } from './local-password-form'

export const UnlockSecureStorageForm = () => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = useMemo(() => reatomUnlockSecureStorage(), [])
  const [state] = useAtom(model)

  const unlock = useAction(model.execute)

  const mappedState = useMemo(
    () =>
      state.pipe(
        AsyncStateN.mapLeft((it) =>
          it instanceof WrongPasswordError ? it : UnknownError.fromUnknown(it),
        ),
      ),
    [state],
  )

  return (
    <LocalPasswordForm
      state={mappedState}
      onSubmit={(password) => {
        unlock({ password })
      }}
    />
  )
}
